// extracted by mini-css-extract-plugin
module.exports = {"container":"MatchBlockContainer_container__GiFJ7"};